import React from 'react';
import { withRouter } from 'react-router-dom';
import AuthLayout from '../../components/AuthLayout';

const Login = ({ history }) => {
  return (
    <AuthLayout
      title="Choose your workspace"
      subtitle="Select the portal that matches your role."
    >
      <div className="auth-role-list">
        <button
          onClick={() => history.push('/login/admin')}
          className="auth-role-button"
        >
          <span className="auth-role-icon"><i className="fas fa-user-shield" /></span>
          <span><strong>Admin</strong><small>Manage people and operations</small></span>
          <i className="fas fa-arrow-right" />
        </button>
        <button
          onClick={() => history.push('/login/client')}
          className="auth-role-button"
        >
          <span className="auth-role-icon"><i className="fas fa-building" /></span>
          <span><strong>Client</strong><small>View your workforce workspace</small></span>
          <i className="fas fa-arrow-right" />
        </button>
        <button
          onClick={() => history.push('/login/supervisor')}
          className="auth-role-button"
        >
          <span className="auth-role-icon"><i className="fas fa-users-cog" /></span>
          <span><strong>Supervisor</strong><small>Coordinate teams and schedules</small></span>
          <i className="fas fa-arrow-right" />
        </button>
      </div>
    </AuthLayout>
  );
};

export default withRouter(Login);
